/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Personas_Store_Install_SuccessInputs */



/**
* | output |
* | --- |
* | "\"{name}\" installed." |
*
* @param {Personas_Store_Install_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_store_install_success = /** @type {((inputs: Personas_Store_Install_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Store_Install_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`"${i?.name}" installiert.`)
	return /** @type {LocalizedString} */ (`"${i?.name}" installed.`)
});